const stripeJs = require('@stripe/stripe-js');

( async function (a) {

    const $paymentForm = a('#payment-details-card');
    const $paymentReviewAndConfirm = a('#review-and-confirm-card');

    if (!!$paymentForm.length) {
        const stripe = await stripeJs.loadStripe(window.Spikkl.stripe_public_key);

        const $ibanField = $paymentForm.find('#iban');
        const $debitHolder = $paymentForm.find('#debit-owner');

        const $creditCardField = $paymentForm.find('#credit-card');
        const $creditCardHolder = $paymentForm.find('#credit-card-holder');

        const $email = $paymentForm.find('#billing-email');

        const $detailSubmitButton = $paymentForm.find("[type=submit]");
        const $paymentMethodButtons = $paymentForm.find('.payment-method-switcher button');

        $paymentMethodButtons.on('click', function (event) {
            const value = a(event.currentTarget).val();

            a('.is-credit-card').toggle(value === 'creditCard');
            a('.is-direct-debit').toggle(value === 'directDebit');

            $paymentMethodButtons.each( (index, element) => {
                a(element).removeClass('is-selected');
            });

            a(event.currentTarget).addClass('is-selected');
        });

        const elements = stripe.elements();

        const style = {
            base: {
                color: "#1d2d35",
                fontSize: "16px"
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            }
        };

        const options = {
            style,
            supportedCountries: [ 'SEPA' ],
            placeholderCountry: 'NL'
        };

        const creditCard = elements.create('card');
        creditCard.mount($creditCardField.get(0));

        const iban = elements.create('iban', options);
        iban.mount($ibanField.get(0));

        $detailSubmitButton.on('click', (event) => {
            event.preventDefault();
            $detailSubmitButton.addClass('is-loading');

            let method = {};
            if (a('.is-credit-card').is(':visible')) {
                method = { type: 'card', card: creditCard };
            } else if (a('.is-direct-debit').is(':visible')) {
                method = { type: 'sepa_debit', sepa_debit: iban };
            } else {
                $detailSubmitButton.removeClass('is-loading');

                return $paymentForm.find('form').submit();
            }

            method = Object.assign(method, {
                billing_details: {
                    email: $email.val(),
                    name: $debitHolder.val() || $creditCardHolder.val()
                }
            });

            stripe.createPaymentMethod(method).then( (response) => {
                if (response.error) {
                    $detailSubmitButton.removeClass('is-loading');
                } else {
                    $paymentForm.find('#payment-method').val(response.paymentMethod.id);
                    $paymentForm.find('form').submit();
                }
            });
        });
    }

    if (!!$paymentReviewAndConfirm.length) {
        const $termsConsent = $paymentReviewAndConfirm.find('#terms-consent');
        const $reviewSubmitButton = $paymentReviewAndConfirm.find("[type=submit]");

        $termsConsent.on('click', (event) => {
            if (a(event.target).is(':checked')) {
                $reviewSubmitButton.prop('disabled', false);
            } else {
                $reviewSubmitButton.prop('disabled', 'disabled');
            }
        });

        $reviewSubmitButton.on('click', () => {
            $reviewSubmitButton.addClass('is-loading');
        });
    }
}(jQuery));
